import {createStore, compose, applyMiddleware} from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import rootReducer from '../reducers';
import { get } from 'lodash';

import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
import SplunkLogger from '../utils/splunkClientLogger';

const splunkLoggerReduxMiddlewareConfig = {
  includeFromState: function(state) {
    return {
      user: {
        id: get(state, 'user.id', 'undefined'),
        username: get(state, 'user.username', 'undefined'),
        sfid: get(state, 'user.sfid', 'undefined'),
        email: get(state, 'user.email', 'undefined'),
        type: get(state, 'user.type', 'undefined'),
        lang: get(state, 'user.lang', 'undefined'),
        user_uuid: get(state, 'user.uuid', 'undefined')
      }
    };
  }
};

// routing middleware for react-router-redux, required for redux-auth-wrapper
const routingMiddleware = routerMiddleware(browserHistory);

function createEnhancer(middlewares) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools

  return composeEnhancers(
    applyMiddleware(...middlewares)
  );
}

function configureStoreProd(initialState, callback) {
  const enhancer = createEnhancer([routingMiddleware, thunk, SplunkLogger.reduxMiddleware(splunkLoggerReduxMiddlewareConfig)]);
  const store = createStore(rootReducer, initialState, enhancer);
  callback(store);
}

function configureStoreDev(initialState, callback) {
  const middlewares = [

    // Add other middleware on this line...
    routingMiddleware,

    // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
    reduxImmutableStateInvariant(),

    // thunk middleware can also accept an extra argument to be passed to each thunk action
    // https://github.com/gaearon/redux-thunk#injecting-a-custom-argument
    thunk,
    SplunkLogger.reduxMiddleware(splunkLoggerReduxMiddlewareConfig)
  ];

  const enhancer = createEnhancer(middlewares);
  const store = createStore(rootReducer, initialState, enhancer);

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(nextReducer);
    });
  }

  callback(store);
  return store;
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js